import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import { Content, Root } from 'mdast';

const parser = unified().use(remarkParse).use(remarkGfm);

export const shortenHistory = (text: string, limit: number): string => {
  if (text.length <= limit) return text;

  let end = limit;
  const visit = (node: Root | Content) => {
    const start = node.position?.start.offset;
    const stop = node.position?.end.offset;
    if (
      (node.type === 'link' || node.type === 'strong') &&
      start !== undefined &&
      stop !== undefined &&
      start < end &&
      end < stop
    ) {
      end = stop;
    }
    if ('children' in node) node.children.forEach(visit);
  };
  visit(parser.parse(text));

  return end >= text.length ? text : `${text.slice(0, end)} ...`;
};
